<div id="canvas-holder">
  <canvas #roomCanvasElement width="550" height="500" class="mat-elevation-z1"></canvas>

  <app-canvas-controls [canvas]="roomCanvas"
                       [ignorePanOnSelection]="assetSelectionDisabled"
                       (zoomChange)="onCanvasZoomChangeAsync()">
  </app-canvas-controls>
</div>
